export const BASE_URL = process.env.REACT_APP_API_URL;

export const API_CONSTANTS = {
  LOOKUP_COUNTIES: `${BASE_URL}/Lookup/counties`,
  LOOKUP_INSURERS: `${BASE_URL}/Lookup/insurers`,
  LOOKUP_COVERAGE_CODES: `${BASE_URL}/Lookup/coverage-codes`,
  REPORT_SUMMARY: `${BASE_URL}/Report/summary`,
  REPORT_QUARTERLY_PREMIUM_TREND: `${BASE_URL}/Report/quarterly-premium-trend`,
  REPORT_FAST_FACTS: `${BASE_URL}/Report/fast-facts`,
  REPORT_TOP_INSURERS: `${BASE_URL}/Report/top-insurers`,
  REPORT_COUNTY_DATA: `${BASE_URL}/Report/county-data`,
  REPORT_INSURER_WISE_DATA: `${BASE_URL}/Report/insurer-wise-data`,
  REPORT_COUNTY_WISE_DATA: `${BASE_URL}/Report/county-wise-data`,
  REPORT_TRANSACTION_TRENDS: `${BASE_URL}/Report/transaction-trends`,
  REPORT_COVERAGE_CODE_WISE_DATA: `${BASE_URL}/Report/coverage-code-wise-data`,
};
